import React, { FC } from 'react';
import { FormComponentProps } from '../../global-forms/GlobalForms.types';

import styles from './MeetingCreationForm.module.scss';

export const MeetingCreationForm: FC<
  FormComponentProps & {
    selectedInterval?: Interval;
    eventTypeSelection: JSX.Element | null;
  }
> = (props) => {
  const { eventTypeSelection } = props;

  return (
    <div className={styles.form}>
      <div className={styles.body}>
        <div className={styles.bodyOverflowContainer}>{eventTypeSelection}</div>
      </div>
    </div>
  );
};
